import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/tailwind.css";
import axios from "axios";
import Swal from "sweetalert2";
//import 'sweetalert2/src/sweetalert2.scss'

const app = createApp(App)
  .use(store)
  .use(router);

const instance = axios.create({
  baseURL: "http://stratochange-001-site7.btempurl.com/"
  //timeout: 1000 * 12
});
const swal = Swal.mixin({
  confirmButtonColor: "#0367B5"
});
app.config.globalProperties.$hiro = "New hiro";
app.config.globalProperties.$axios = instance;
app.config.globalProperties.$swal = swal;
app.config.globalProperties.$toast = swal.mixin({
  toast: true,
  position: "bottom-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: toast => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  }
});

app.mount("#app");
